import { useCurrentUser } from "./useCurrentUser";

export function useCurrentUserTimezone() {
  return useCurrentUser()?.timezone;
}
